import { CSSProperties, useContext } from 'react';
import ThemeContext from '../contexts/ThemeContext';
import '../styles/Background.css';

const NUM_BUBBLES = 10;

function Background() {
  const { showBubbles, backgroundColorHex } = useContext(ThemeContext);

  const style: CSSProperties = {
    backgroundColor: backgroundColorHex
  }

  return (
    <div className='Background' style={style}>
      {[...Array(NUM_BUBBLES)].map((_, i) => <div className={`Background-bubble ${showBubbles ? 'bg-white' : 'bg-none'}`} key={i} />)}
    </div>
  );
}

export default Background;
